<template>
    <div id="staff-grade" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <span class="go-back" @click="$router.go(-1)"><i class="iconfont icon-fanhui"></i>返回交接班记录</span>
        <div class="staff-filter">
            <div class="search">
                <input type="text" name="" id="" v-model="searchOrderId" placeholder="输入订单号查询">
                <button @click="searchByOrderId">
                    <i class="iconfont icon-sousuo"></i>
                </button>
            </div>
        </div>
        <div class="staff-info">
          <span class="staff-name">交班人：{{$route.query.closeUsername}}</span>
          <span class="staff-time">交班时间：{{$route.query.beginTime | numberToMonthDate('') }}~{{$route.query.endTime | numberToMonthDate('') }}</span>
        </div>
        <div class="in-and-out clearfix">
            <div class="tit">收入退单</div>
            <div class="pie">
                <div class="income left">
                    <div id="income-pie" class="pie-for-income left" v-show="showPie"></div>
                    <div class="no-income" v-show="!showPie"><span>暂无任何收入数据</span></div>

                    <!-- <div class="tip-info left">
                        <ul>
                            <li class="wechat">
                                <span class="tip-color"></span>
                                <span class="tip-cont">微信收入：{{gradeDataForPie.adminPayBill.wx}}元( {{gradeDataForPie.adminPayBill.wxCount+"笔"}} )</span>
                            </li>
                            <li class="ali">
                                <span class="tip-color"></span>
                                <span class="tip-cont">支付宝收入：{{gradeDataForPie.adminPayBill.ali}}元( {{gradeDataForPie.adminPayBill.alCount+"笔"}} )</span>
                            </li>
                            <li class="cash">
                                <span class="tip-color"></span>
                                <span class="tip-cont">现金收入：{{gradeDataForPie.adminPayBill.cash}}元( {{gradeDataForPie.adminPayBill.cashCount+"笔"}} )</span>
                            </li>
                            <li class="yl">
                                <span class="tip-color"></span>
                                <span class="tip-cont">银联收入：{{gradeDataForPie.adminPayBill.yl}}元( {{gradeDataForPie.adminPayBill.ylCount+"笔"}} )</span>
                            </li>
                        </ul>
                    </div> -->
                </div>
                <div class="out left">
                    <div id="out-pie" class="pie-for-out left"></div>
                    <div class="tip-info left">
                        <ul>
                            <li class="out-tip">
                                <span class="tip-color"></span>
                                <span class="tip-cont">退款：{{gradeDataForPie.refundTotalAmount | toFixedNum}}元</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="in-and-out-list">
            <div class="tit">收入退单</div>
            <table style="width:100%;">
                <tr style="width:100%;">
                  <th style="width:3%;">序号</th>
                  <th style="width:6%;">座号</th>
                  <th style="width:13%;">时间</th>
                  <th style="width:7%;">实收</th>
                  <th style="width:7%;">应收</th>
                  <th style="width:5%;">折扣</th>
                  <th style="width:4%;">抹零</th>
                  <th style="width:10%;">支付方式</th>
                  <th style="width:6%;">结账员工</th>
                  <th style="width:8%;">订单来源</th>
                  <th style="width:25%;">订单号</th>
                  <th style="width:6%;">详情</th>
                </tr>
            </table>
            <div class="list">
                <table style="width:100%;" v-if="gradeListData.length>0">
                  <tr style="width:100%;" v-for="(item,index) in gradeListData" :key="index">
                    <td style="width:3%;" class="index-count">
                      <i v-if="item.amount<0" class="iconfont icon-tui"></i>
                      {{index+1+(currentPage-1)*pageSize}}
                    </td>
                    <td style="width:6%;">{{item.tableNo?item.tableNo:"无"}}</td>
                    <td style="width:13%;" v-if="item.amount<0">{{item.refundTime | dateForGradePage}}</td>
                    <td style="width:13%;" v-else>{{item.createTime | dateForGradePage}}</td>
                    <td style="width:7%;" class="amount">{{item.amount}}</td>
                    <td style="width:7%;" class="amount">{{item.total}}</td>
                    <td style="width:5%;" class="amount">{{item.discount}}</td>
                    <td style="width:4%;" class="amount">{{item.removeZero}}</td>
                    <td style="width:10%;">{{payType[item.paymentChannel]}}</td>
                    <td style="width:6%;">{{item.creatorName}}</td>
                    <td style="width:8%;">{{sourceType[item.source]}}</td>
                    <td style="width:25%;">{{item.orderId}}</td>
                    <th style="width:6%;color:blue;cursor:pointer;" @click="showOrderDetail(item)">详情</th>
                  </tr>
                    <!-- <tr style="width:100%;" v-for="(item,index) in gradeListData" :key="index">
                        <td style="width:10%;" class="index-count">
                          <i v-if="item.amount<0" class="iconfont icon-tui"></i>
                          {{index+1+(currentPage-1)*pageSize}}
                        </td>
                        <td style="width:25%;">{{item.createTime | dateForGradePage}}</td>
                        <td style="width:15%;" class="amount">{{item.amount | toFixedNum}}</td>
                        <td style="width:15%;">{{payType[item.paymentChannel]}}</td>
                        <td style="width:35%;">{{item.orderId}}</td>
                    </tr> -->
                </table>
                <div class="no-data" v-else>暂无数据</div>
            </div>
            <div class="pagination">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="totalElements">
                </el-pagination>
            </div>
        </div>
        <div class="loading">

        </div>
        <el-dialog
        title="订单详情"
        :visible.sync="doShowOrderDetail"
        width="15%"
        >
        <div style="max-height:300px;overflow:hidden;overflow-y:scroll;">
          <table style="width:100%;">
            <tr>
              <th>名称</th>
              <th>数量</th>
              <th>金额</th>
              <th>会员名称</th>
              <th>会员号码</th>
            </tr>
            <tr style="width:100%;" v-for="(item,index) in orderDetailData" :key="index">
              <td style="text-align:center;padding:5px 0;">{{item.productName}}</td>
              <td style="text-align:center;padding:5px 0;">{{item.qty}}</td>
              <td style="text-align:center;padding:5px 0;">{{item.amount}}</td>
              <td style="text-align:center;padding:5px 0;">{{item.memberName?item.memberName:'无'}}</td>
              <td style="text-align:center;padding:5px 0;">{{item.mobile?item.mobile:'无'}}</td>
            </tr>
          </table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="doShowOrderDetail = false">取 消</el-button>
          <el-button type="primary" @click="doShowOrderDetail = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import echarts from "echarts";

export default {
  name: "dailyGrade",
  props: ["curStoreId"],
  data() {
    return {
      doShowOrderDetail:false,
      orderDetailData:[],
      sourceType: { // 订单来源类型
				POS: "收银台",
				WEB: "电脑点单",
				EMPLOYEE: "店员宝",
				WEIXIN: "微信点单",
				CONSUMER: "消费者，微信",
				TAKEOUT: "三方外卖"
			},
      workShiftId:"",//当前班次id
      pieForIncome: null, //收入饼状图
      pieForOut: null, //支出饼状图
      currentPage: 1,
      pageSize: 10,
      gradeDataForPie: {
        adminPayBill: {
          ali: 0,
          cash: 0,
          returnTotal: 0,
          wx: 0
        },
        refundTotalAmount: 0,//退总款金额
        successTotalAmount: 0//总收入
      }, //经营日报的数据
      gradeListData: [], //经营日报列表数据
      searchOrderId: "", //所搜索的订单id
      payType: {
        "CASH": "现金",
        "ALIPAY": "支付宝",
        "WECHATPAY": "微信",
        "UNIONPAY": "银联",
        "pay.weixin.micropay":"微信刷卡",
        "pay.wechat.micropay":"微信刷卡",
        "pay.alipay.micropay":"支付宝刷卡",
        "pay.jdpay.micropay":"京东刷卡",
        "pay.qq.micropay":"QQ钱包刷卡",
        "pay.shiming.micropay":"会员卡",
        "pay.unionpay.micropay":"银联支付",
        "pay.bestpay.micropay":"翼支付",
        "pay.weixin.native":"微信扫码",
        "pay.wechat.native":"微信扫码",
        "pay.alipay.native":"支付宝扫码",
        "ALIPAY_CASH":"支付宝线下",
        "WECHATPAY_CASH":"微信线下",
        "COUPON":"优惠券",
        "MEMBER":"会员",
        "pay.wechat.jspay":"微信网页支付",
        "pay.alipay.jspay":"支付宝网页支付",
      },
      totalElements: 0, //数据总条数
      loading: true,
      showPie:false//在没有数据的情况下是否显示饼状图
    };
  },
  methods: {
    showOrderDetail(item){
      this.$http({
        url: "get-item",
        method: "GET",
        params: {
          orderId: item.orderId
        }
      }).then(res => {
        this.doShowOrderDetail = true;
        this.orderDetailData = res.data;
      });
    },
    //按订单查询
    searchByOrderId() {
      this.$http({
        url: "get-storeBill",
        method: "GET",
        params: {
          orderId: this.searchOrderId
        }
      }).then(res => {
        console.log(res);
        this.gradeListData = res.data.data;
        this.totalElements = 0;
      });
    },
    //分页方法
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getData(val - 1,false);
    },
    drawPieForIncome(data,incomeData) {
      if (this.pieForIncome) {
        this.pieForIncome.dispose();
      }
      this.pieForIncome = echarts.init(document.getElementById("income-pie"));
      let legendData = [];
      for (let i = 0; i < incomeData.length; i++) {
        legendData.push(incomeData[i].name);
      }
      let option = {
        title: {
          text: `总收入:${Number(data.successTotalAmount).toFixed(2)}( ${data.successCount}笔 )`,
          x: "left",
          padding: 15,
          textStyle: {
            color: "#000",
            fontSize: 16
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} "
        },
        legend: {
          orient: "vertical",
          right:"20%",
          data: legendData,
          top: "middle",
          type: "scroll"
        },
        color: ["#55a8dc", "#6fcd58", "#e78d61","#000000"],
        series: [
          {
            name: "收入来源",
            type: "pie",
            radius: "55%",
            center: ["35%", "50%"],
            label: {
              normal: {
                position: "inner",
                show: false
              }
            },
            data: incomeData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      setTimeout(() => {
        this.pieForIncome.setOption(option);
      }, 200);
    },
    drawPieForOut(data) {
      if (this.pieForOut) {
        this.pieForOut.dispose();
      }
      this.pieForOut = echarts.init(document.getElementById("out-pie"));
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        title: {
          text: `退单:${Number(data.refundTotalAmount).toFixed(2)}( ${data.refundCount}笔 )`,
          x: "left",
          padding: 15,
          textStyle: {
            color: "#000",
            fontSize: 16
          }
        },
        color: ["#37d6b7"],
        series: [
          {
            name: "退单",
            type: "pie",
            radius: ["30%", "55%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [{ value: data.refundTotalAmount, name: "退款" }]
          }
        ]
      };
      setTimeout(() => {
        this.pieForOut.setOption(option);
      }, 200);
    },
    //获取数据
    getData(page = 0, isUpdatePie = true) {
      this.loading = true;
      this.$http({
        url: "get-storeBill",
        method: "GET",
        params: {
          workShiftId:this.$route.query.workShiftId,
          page: page,
          size: this.pageSize,
          source:"workShift"
        }
      }).then(res => {
        if (res.status === 200) {
          console.log(res);
          this.gradeDataForPie = res.data;
          this.gradeListData = res.data.data;
          this.totalElements = res.data.totalElements;
          //绘制饼图
          
          let data = res.data;
          let billInfo = JSON.parse(data.adminPayBill);
          console.log(billInfo);
          let incomeData = [];
          if (billInfo.adminPayBill.length) {
            this.showPie = true;
            // 提取信息
            for (let i = 0; i < billInfo.adminPayBill.length; i++) {
              let amountObj = {};
              amountObj.value = Number(billInfo.adminPayBill[i].amount).toFixed(2);
              amountObj.count = billInfo.adminPayBill[i].count;
              switch (billInfo.adminPayBill[i].channel) {
                // case "pay.weixin.micropay":
                //   amountObj.name = "微信刷卡";
                //   amountObj.itemStyle = { normal: { color: "#e29fbf" } };
                //   break;
                // case "pay.alipay.micropay":
                //   amountObj.name = "支付宝刷卡";
                //   amountObj.itemStyle = { normal: { color: "#d69947" } };
                //   break;
                // case "pay.jdpay.micropay":
                //   amountObj.name = "京东刷卡";
                //   amountObj.itemStyle = { normal: { color: "#d17c42" } };
                //   break;
                case "jdMicroPay":
                  amountObj.name = "京东刷卡";
                  amountObj.itemStyle = { normal: { color: "#d17c42" } };
                  break;
                // case "pay.qq.micropay":
                //   amountObj.name = "QQ钱包刷卡";
                //   amountObj.itemStyle = { normal: { color: "#b3c125" } };
                //   break;
                case "qqMicroPay":
                  amountObj.name = "QQ钱包刷卡";
                  amountObj.itemStyle = { normal: { color: "#b3c125" } };
                  break;
                // case "pay.shiming.micropay":
                //   amountObj.name = "会员卡";
                //   amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                //   break;
                case "smMicroPay":
                  amountObj.name = "会员卡";
                  amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                  break;
                // case "pay.unionpay.micropay":
                //   amountObj.name = "银联支付";
                //   amountObj.itemStyle = { normal: { color: "#ff9e9c" } };
                //   break;
                case "unionPay":
                  amountObj.name = "银联支付";
                  amountObj.itemStyle = { normal: { color: "#ff9e9c" } };
                  break;
                // case "pay.bestpay.micropay":
                //   amountObj.name = "翼支付";
                //   amountObj.itemStyle = { normal: { color: "#ea7f5e" } };
                //   break;
                case "wingPayAmount":
                  amountObj.name = "翼支付";
                  amountObj.itemStyle = { normal: { color: "#ea7f5e" } };
                  break;
                // case "pay.weixin.native":
                //   amountObj.name = "微信扫码";
                //   amountObj.itemStyle = { normal: { color: "#8ecc52" } };
                //   break;
                // case "pay.alipay.native":
                //   amountObj.name = "支付宝扫码";
                //   amountObj.itemStyle = { normal: { color: "#41bbd8" } };
                //   break;
                case "CASH":
                  amountObj.name = "现金";
                  amountObj.itemStyle = { normal: { color: "#3bbddb" } };
                  break;
                case "cashAmount":
                  amountObj.name = "现金";
                  amountObj.itemStyle = { normal: { color: "#3bbddb" } };
                  break;
                case "WECHATPAY":
                  amountObj.name = "微信";
                  amountObj.itemStyle = { normal: { color: "#51c332" } };
                  break;
                case "wechatAmount":
                  amountObj.name = "微信";
                  amountObj.itemStyle = { normal: { color: "#51c332" } };
                  break;
                case "ALIPAY":
                  amountObj.name = "支付宝";
                  amountObj.itemStyle = { normal: { color: "#d69947" } };
                  break;
                case "alipayAmount":
                  amountObj.name = "支付宝";
                  amountObj.itemStyle = { normal: { color: "#56abe4" } };
                  break;
                case "UNIONPAY":
                  amountObj.name = "银联";
                  amountObj.itemStyle = { normal: { color: "#ff9e9c" } };
                  break;
                case "ALIPAY_CASH":
                  amountObj.name = "支付宝线下";
                  amountObj.itemStyle = { normal: { color: "#d69947" } };
                  break;
                case "WECHATPAY_CASH":
                  amountObj.name = "微信线下";
                  amountObj.itemStyle = { normal: { color: "#51c332" } };
                  break;
                case "COUPON":
                  amountObj.name = "优惠券";
                  amountObj.itemStyle = { normal: { color: "#619ce2" } };
                  break;
                case "couponAmount":
                  amountObj.name = "优惠券";
                  amountObj.itemStyle = { normal: { color: "#619ce2" } };
                  break;
                case "MEMBER":
                  amountObj.name = "会员";
                  amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                  break;
                case "memberAmount":
                  amountObj.name = "会员";
                  amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                  break;
                case "memberRechargeAmount":
                  amountObj.name = "会员充值";
                  amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                  break;
                default:
                  break;
              }
              amountObj.name = `${amountObj.name}:${amountObj.value}元(${amountObj.count}笔)`;
              // amountObj[billInfo.amount[i][0]] =  billInfo.amount[i][1];
              incomeData.push(amountObj);
            }
            console.log(incomeData);
            if (isUpdatePie) {
              setTimeout(() => {
                this.drawPieForIncome(data, incomeData);
                this.drawPieForOut(this.gradeDataForPie);
              }, 150);
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.showPie = false;
            if (this.pieForIncome) {
              this.pieForIncome.dispose();
            }
            if (isUpdatePie) {
              setTimeout(() => {
                this.drawPieForOut(this.gradeDataForPie);
              }, 150);
            }
          }
        }else if (res.status === 500) {
          this.loading = false;
          this.$message({
            message: "系统运行错误",
            customClass: "error",
            showClose: true
          });
        }
      });
    }
  },
  mounted() {
    // 获取数据初进页面，没有订单号查询
    this.workShiftId = this.$route.query.workShiftId;
    this.getData();
    console.log(this.$route.query);
  }
};
</script>

<style lang="scss" scoped>
@import "./staffGrade.scss";
</style>



// WEBPACK FOOTER //
// staffGrade.vue?5e67fbc7